import React, { useState } from "react";

import { toast } from "react-toastify";

import "../CSS/contactus.css";

function Contact() {



  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: ""
  });

  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {

    e.preventDefault();


    if (
      !formData.name ||
      !formData.email ||
      !formData.message
    ) {
      toast.error("Please fill in all required fields.");
      return;
    }

    try {

      setLoading(true);


      const response = await fetch(
        "https://www.ypersystem.com/api/contact.php",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            ...formData,
          })
        }
      );

      const result = await response.json();

      if (!response.ok || !result.success) {
        throw new Error(
          result.message || "Unable to send your message."
        );
      }

      toast.success(
        "Thank you! Your message has been sent successfully."
      );

      setFormData({
        name: "",
        email: "",
        phone: "",
        subject: "",
        message: ""
      });

    } catch (error) {

      console.error("Contact form error:", error);

      toast.error(
        error.message ||
        "Something went wrong. Please try again."
      );

    } finally {
      setLoading(false);
    }
  };

  return (

    <div className="contact-page">

      {/* Hero */}
      <section className="contact-hero">

        <div className="container">

          <div className="about-hero-content">

            <h1>
              Let's Build Something
              <br />
              <span>
                Great Together
              </span>
            </h1>

            <p>
              Tell us about your project, business requirements, or
              software idea. We'd love to hear from you.
            </p>

          </div>

        </div>

      </section>


      {/* Contact Area */}
      <section className="contact-section">

        <div className="container">

          <div className="row g-5">

            {/* LEFT */}
            <div className="col-lg-5">

              <div className="contact-info">

                <span>GET IN TOUCH</span>

                <h2>
                  Let's Talk About Your Project
                </h2>

                <p>
                  Whether you need custom software, an ERP system,
                  a web application, or ongoing technical support,
                  our team is ready to help.
                </p>

                <div className="contact-detail">

                  <strong>Email</strong>

                  <p>
                    ypersystem@gmail.com
                  </p>

                </div>

                <div className="contact-detail">

                  <strong>Business Hours</strong>

                  <p>
                    Monday – Friday | 9:00 AM – 6:00 PM
                  </p>

                </div>

              </div>

            </div>


            {/* RIGHT - FORM */}
            <div className="col-lg-7">

              <div className="contact-form-card">

                <h3>
                  Send Us a Message
                </h3>

                <form onSubmit={handleSubmit}>

                  <div className="row g-4">

                    {/* Name */}
                    <div className="col-md-6">

                      <label htmlFor="name">
                        Name *
                      </label>

                      <input
                        type="text"
                        id="name"
                        name="name"
                        value={formData.name}
                        onChange={handleChange}
                        placeholder="Your name"
                        required
                      />

                    </div>


                    {/* Email */}
                    <div className="col-md-6">

                      <label htmlFor="email">
                        Email *
                      </label>

                      <input
                        type="email"
                        id="email"
                        name="email"
                        value={formData.email}
                        onChange={handleChange}
                        placeholder="your@email.com"
                        required
                      />

                    </div>


                    {/* Phone */}
                    <div className="col-md-6">

                      <label htmlFor="phone">
                        Phone
                      </label>

                      <input
                        type="tel"
                        id="phone"
                        name="phone"
                        value={formData.phone}
                        onChange={handleChange}
                        placeholder="+91 XXXXX XXXXX"
                      />

                    </div>


                    {/* Subject */}
                    <div className="col-md-6">

                      <label htmlFor="subject">
                        Subject
                      </label>

                      <input
                        type="text"
                        id="subject"
                        name="subject"
                        value={formData.subject}
                        onChange={handleChange}
                        placeholder="How can we help?"
                      />

                    </div>


                    {/* Message */}
                    <div className="col-12">

                      <label htmlFor="message">
                        Message *
                      </label>

                      <textarea
                        id="message"
                        name="message"
                        rows="6"
                        value={formData.message}
                        onChange={handleChange}
                        placeholder="Tell us about your project..."
                        required
                      />

                    </div>


                    {/* Button */}
                    <div className="col-12">

                      <button
                        type="submit"
                        disabled={loading}
                      >

                        {loading
                          ? "Sending..."
                          : "Send Message"
                        }

                      </button>
                      
                    </div>

                  </div>

                </form>

              </div>

            </div>

          </div>

        </div>

      </section>

    </div>
  );
}

export default Contact;